'use strict';

/**
 * Lavazza cart entry: patch SFRA product/base (selectAttribute, colorAttribute)
 * before SFRA cart registers its listeners.
 */
const productBase = require('../product/base');
const baseCart = require('base/cart/cart');

/**
 * Resolves the cart model from SFRA cart:update payloads.
 * Cart-RemoveProductLineItem sends { basket }, Cart-UpdateQuantity sends the model as root.
 *
 * @param {Object} data - AJAX response data from the cart:update event
 * @returns {Object|null} Cart model or null
 */
function getCartModel(data) {
	if (!data) {
		return null;
	}
	return data.basket || data;
}

/**
 * Updates loyalty beans from CartModel.
 * @param {Object} data - AJAX response data from the cart:update event
 */
function updateLoyaltyBeans(data) {
	const basket = getCartModel(data);
	if (basket && basket.totalBeans != null) {
		const $loyalty = $('.cart-right-container__loyalty');

		if ($loyalty.length > 0) {
			const beans = basket.totalBeans || 0;
			$loyalty.find('.beans').text(beans);
			$loyalty.toggleClass('d-none', !beans);
		}
	}
}

/**
 * Keeps Lavazza promo announcement in sync after quantity/promo AJAX updates.
 * SFRA updateCartTotals targets `.item-{UUID}` for renderedPromotions and would wipe
 * the announcement when that class is present / when applied promotions are empty.
 *
 * @param {Object} data - AJAX response data from the cart:update event
 */
function updateLineItemPromoAnnouncements(data) {
	const basket = getCartModel(data);
	const items = basket && basket.items;
	if (!items || !items.length) {
		return;
	}

	items.forEach(function (item) {
		if (!item || !item.UUID) {
			return;
		}

		const $card = $('.uuid-' + item.UUID);
		if (!$card.length) {
			return;
		}

		const announcement = item.tags && item.tags.promoAnnouncement
			? String(item.tags.promoAnnouncement)
			: '';
		const $promo = $card.find('[data-promo-announcement]').first();
		if (!$promo.length) {
			return;
		}

		$promo.find('.product-tile__promo-announcement-text').text(announcement);
		$promo.toggleClass('d-none', !announcement);
	});
}

/**
 * Hides the line error and unlocks plus once the quantity fits the available stock.
 * While the line is still short, the error and the blocked plus stay as rendered.
 * @param {Object} data - AJAX response data from the cart:update event
 */
function updateLineItemAvailability(data) {
	const basket = getCartModel(data);
	const items = basket && basket.items;
	if (!items || !items.length) {
		return;
	}

	items.forEach(function (item) {
		if (!item || !item.UUID || item.available !== true) {
			return;
		}

		const $card = $('.uuid-' + item.UUID);
		if (!$card.length) {
			return;
		}

		$card.find('.cart-line-item__availability').remove();
		$card.find('.cart-line-item__footer-container').removeClass('not-available');
	});
}

function resetCartRefillDrawerState($drawer) {
	const $selectedOption = $drawer.find('[data-cart-refill-frequency-option].is-selected').first();

	$drawer.find('[data-cart-refill-frequency-option]').removeClass('is-active');

	if ($selectedOption.length) {
		$selectedOption.addClass('is-active');
	}
}

module.exports = function () {
	baseCart();

	// Last line removed: SFRA would swap the cart for a bare <h1>. Skip its success handler and reload,
	// keeping the old cart under the spinner SFRA already started until the server empty cart page arrives.
	$.ajaxPrefilter(function (options) {
		const baseSuccess = options.success;

		if (!baseSuccess || !String(options.url || '').includes('Cart-RemoveProductLineItem')) {
			return;
		}

		// eslint-disable-next-line no-param-reassign
		options.success = function (data) {
			if (data && data.basket && data.basket.items && data.basket.items.length === 0) {
				// cart_remove / cart_view_empty tracking (gtm.js) listens to cart:update
				$('body').trigger('cart:update', data);
				window.location.reload();
				return;
			}
			baseSuccess.apply(this, arguments);
		};
	});
	$('.optional-promo').off('click');

	// SFRA binds the whole .bonus-product-button container. Only the select button should open the modal.
	$('body').off('click', '.cart-page .bonus-product-button');
	$('body').on('click', '.cart-page .bonus-product-button__select', function (event) {
		const $container = $(this).closest('.bonus-product-button');

		event.preventDefault();
		event.stopPropagation();

		if (!$container.length) {
			return;
		}

		$.spinner().start();
		$container.addClass('launched-modal');
		$.ajax({
			url: $container.data('url'),
			method: 'GET',
			dataType: 'json',
			success: function (data) {
				productBase.methods.editBonusProducts(data);
				$.spinner().stop();
			},
			error: function () {
				$.spinner().stop();
			}
		});
	});

	// SFRA remove/qty success triggers cart:update with { basket } or the cart model as root
	$('body').on('cart:update', function (event, data) {
		if (!data) {
			return;
		}

		// Cart-RemoveProductLineItem of a gift-earning line: the gift CTA may have moved to another line
		if (data.reloadCart && String($('.page').data('action') || '').startsWith('Cart-')) {
			window.location.reload();
			return;
		}

		updateLoyaltyBeans(data);
		updateLineItemPromoAnnouncements(data);
		updateLineItemAvailability(data);

		// SFRA updateCartTotals writes totalShippingCost into every .shipping-cost, so the struck
		// list price and Free label never follow a quantity change. cartTotals.isml is the source of truth.
		const basket = getCartModel(data);
		const totals = basket && basket.totals;
		if (totals) {
			const isFree = !!totals.freeShipping;
			const $container = $('.cart-right-container__totals-items .shipping-cost-container');
			const $label = $('.cart-right-container__totals-items .shipping-cost-label-container');
			const shippingText =
				totals.totalShippingCostWithoutDiscount || totals.adjustedTotalShippingTotal || totals.totalShippingCost;
			const $price = $container.find('.shipping-cost').first();

			$price.text(shippingText || '');
			$price.toggleClass('text-strike', isFree);
			$container.find('.shipping-cost-free').toggleClass('d-none', !isFree);
			$label.toggleClass('col-6 col-sm-8', isFree).toggleClass('col-8', !isFree);
			$container.toggleClass('col-6 col-sm-4', isFree).toggleClass('col-4', !isFree);
			$('.cart-right-container__totals-items .shipping-taxes').text(totals.totalShippingTax || 0);
		}
	});

	$('body').on('click', '[data-cart-refill-edit]', function () {
		const drawerId = String($(this).attr('data-drawer-open') || '');
		const drawerElement = drawerId ? document.getElementById(drawerId) : null;
		if (drawerElement) {
			resetCartRefillDrawerState($(drawerElement));
		}
	});

	$('body').on('click', '[data-cart-subscription-coffee-show-more]', function (event) {
		const $button = $(this);
		const $subsection = $button.closest('.cart-subscription-drawer__subsection, .cart-subscription-drawer__section--future');
		const $hiddenSlots = $subsection.find('[data-cart-subscription-coffee-slot][hidden]');

		event.preventDefault();

		if (!$hiddenSlots.length) {
			return;
		}

		$hiddenSlots.prop('hidden', false);
		$button.prop('hidden', true);
		$subsection.find('[data-cart-subscription-coffee-show-less]').prop('hidden', false);
	});

	$('body').on('click', '[data-cart-subscription-coffee-show-less]', function (event) {
		const $button = $(this);
		const $subsection = $button.closest('.cart-subscription-drawer__subsection, .cart-subscription-drawer__section--future');
		const $slots = $subsection.find('[data-cart-subscription-coffee-slot]');

		event.preventDefault();

		$slots.each(function (index) {
			$(this).prop('hidden', index >= 3);
		});
		$button.prop('hidden', true);
		$subsection.find('[data-cart-subscription-coffee-show-more]').prop('hidden', $slots.length <= 3);
	});

	$('body').on('click', '[data-cart-refill-frequency-option]', function (event) {
		event.preventDefault();
		event.stopPropagation();
		const $option = $(this);
		const $drawer = $option.closest('[data-cart-refill-drawer]');

		$drawer.find('[data-cart-refill-frequency-option]').removeClass('is-active');
		$option.addClass('is-active');
	});

	$('body').on('click', '[data-cart-refill-save]', function (event) {
		event.preventDefault();
		event.stopPropagation();
		const $button = $(this);
		const $drawer = $button.closest('[data-cart-refill-drawer]');
		const $selectedOption = $drawer.find('[data-cart-refill-frequency-option].is-active').first();
		const selectedFrequency = String($selectedOption.attr('data-cart-refill-frequency-value') || '');
		const pid = String($drawer.attr('data-pid') || '');
		const lineItemID = String($drawer.attr('data-line-item-id') || '');
		const isRegular = String($drawer.attr('data-is-regular')) === 'true';
		const updateUrl = String($drawer.attr('data-update-url') || '');
		const payload = {
			pid: pid,
			lineItemID: lineItemID,
			isRegularSubscription: isRegular
		};
		payload['hasSmartOrderRefill-' + pid] = 'true';
		if (isRegular) {
			payload['deliveryEverySelection-' + pid] = selectedFrequency;
		} else {
			payload['limitedSubscriptionSelection-' + pid] = selectedFrequency;
		}

		if (!pid || !updateUrl || !selectedFrequency) {
			return;
		}

		$button.prop('disabled', true);

		$.ajax({
			url: updateUrl,
			type: 'POST',
			dataType: 'json',
			data: payload,
			lvzSkipAutoSpinner: true
		}).done(function () {
			const pageAction = $('.page').data('action') || '';
			if (String(pageAction).startsWith('Cart-')) {
				window.location.reload();
				return;
			}
			$('body').trigger('cart:update');
		}).always(function () {
			$button.prop('disabled', false);
		});
	});
};
